import type { NodeSn } from '@ipfabric/utils';
import type {
  GraphCommandContext,
  GraphCommandFactory,
} from 'components/Graph/model/GraphCommandContext';
import type { CommandDispatcher } from 'utils/react/useCommandDispatcher';
import { unhighlightEdges } from './unhighlightEdges';
import { unhighlightGraphNode } from './unhighlightGraphNode';

export interface DestroyPathLookupPathInspectorNodeCommand {
  nodeSn: NodeSn;
}

const destroyPathInspectorNode = (
  nodeSn: NodeSn,
  cmdContext: GraphCommandContext,
  dispatch: CommandDispatcher<GraphCommandContext>,
) => {
  cmdContext.updateState((draft) => {
    const { highlightedEdges } = draft.pathlookup.pathInspector;
    if (highlightedEdges[nodeSn] !== undefined) {
      dispatch(unhighlightEdges, {
        color: true,
        edges: [
          // Fixed noUncheckedIndexedAccess NIM-19408
          ...highlightedEdges[nodeSn]!.incomingEdges,
          ...highlightedEdges[nodeSn]!.outgoingEdges,
        ],
      });
      delete draft.pathlookup.pathInspector.enlargedEdges[nodeSn];
      delete draft.pathlookup.pathInspector.highlightedEdges[nodeSn];
      delete draft.pathlookup.pathInspector.selectedPackets[nodeSn];
    }

    if (draft.highlightedNodeId !== null) {
      draft.highlightedNodeId = null;
    }
  });
};

const unhighlightCurrentNode = (
  nodeSn: NodeSn,
  cmdContext: GraphCommandContext,
  dispatch: CommandDispatcher<GraphCommandContext>,
) => {
  if (cmdContext.getState().highlightedNodeId !== null) {
    dispatch(unhighlightGraphNode, { nodeSn });
  }
};

export const destroyPathLookupPathInspectorNode: GraphCommandFactory<
  DestroyPathLookupPathInspectorNodeCommand
> = (cmdContext, dispatch) => (command) => {
  unhighlightCurrentNode(command.nodeSn, cmdContext, dispatch);
  destroyPathInspectorNode(command.nodeSn, cmdContext, dispatch);
};
